<template>
    <div class="content">

        <toolbar v-bind:selection="toolbar" title="Editar colmena mini" />


        <v-form ref="form" v-model="valid" lazy-validation>


            <v-text-field
                    v-model="infoform.name"
                    color="orange"
                    label="Nombre*"
                    :rules="nameRules"
                    type="number"
            ></v-text-field>


      <!--    <v-text-field
                    v-model="infoform.traslarve"
                    color="orange"
                    label="Traslarve*"
            ></v-text-field>
-->

            <p><b>Descripción</b></p>
            <v-col class="col" cols="12" md="6">
                <v-textarea
                        class="nonebold"
                        solo
                        id="description"
                        name="description"
                        label="Información adicional"
                        v-model="infoform.description"
                ></v-textarea>
            </v-col>


            <loading v-bind:isloading="isloading" ></loading>

            <v-alert
                    dense
                    v-bind:type="alertForm"
                    text
                    :value="alert"
                    transition="scale-transition"
            >
                {{responseform}}
            </v-alert>

            <v-btn :disabled="!valid" class="mr-4 btn-yellow" @click="validate">
                EDITAR
            </v-btn>
        </v-form>

    </div>
</template>

<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import loading from "@/components/Loader"


import axios from "axios";


export default {
    name: 'colmena-mini-nueva',
    components: {
        toolbar,
        loading,
    },
    data() {
        return {
            toolbar: {
              return: '0',
            },
        isloading:'',

        valid: true,

            nameRules: [
                v => !!v || 'Requerido',
                v => (v && v.length <= 25) || 'Debe ser inferior a 25 caracteres',
            ],

            /* mensaje resultado form */
            alertForm:'success',
            responseform:'',
            alert: false,


            infoform: {
                name:'',
                description:'',
            },
            info: null
        }
    },

  created() {
  auth.getUserLogged()
    this.getTodos();
  },
    methods:{

        async getTodos(){
            var that = this
            await axios.get("https://appws.panimiel.com/new/index.php/api/hive_mini/detail/"+this.$route.params.id).then((info) => {
              that.info = info.data
              that.infoform.name = that.info.name
              that.infoform.description = that.info.description

             })
        },

         validate () {

            if(this.$refs.form.validate()){

                this.alert = false
                this.isloading = true

                axios.put('https://appws.panimiel.com/new/index.php/api/hive_mini/'+this.$route.params.id, this.infoform)
                     .then((response) => {
                     this.responseform = response.data


                     this.alertForm = 'success'
                     this.isloading=''
                     this.alert = true
                })
                .catch((error) => {
                    this.alertForm = 'error',
                    this.isloading=''

                    if (error.response.status != 500){
                        this.responseform = error.response.data
                    }else{
                        this.responseform = 'Error, no ha sido posible insertar la colmena mini.'
                    }
                     this.alert = true
                 })
            }

        }


    }
}
</script>